<template>
    <nav class="navbar">
        <div class="container">
            <div class="navbar-brand">
                <span class="navbar-burger burger" data-target="navbarMenu">
                                <span></span>
                        <span></span>
                        <span></span>
                        </span>
            </div>
            <div id="navbarMenu" class="navbar-menu">
                <div class="navbar-end">
                    <!--<a @click="$parent.recomecar" class="navbar-item">
                        Recomeçar
                    </a>-->
                    <a class="navbar-item" @click="$root.$children[0].toggleAboutScreen()">
                        Sobre
                    </a>
                    <a class="navbar-item" @click="$root.$children[0].toggleHelpScreen()">
                        Ajuda
                    </a>
                    <div class="navbar-item has-dropdown is-hoverable">
                        <a class="navbar-link">
                            Conta
                        </a>
                        <div class="navbar-dropdown">
                            <div class="navbar-item">
                                <router-link to="/">Sair</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
    export default {
        name: 'NavBar'
    }
</script>

<style>
</style>
